import React, { useEffect, useState } from "react";
import { Card, CardBody, Table, Button, Badge } from "reactstrap";
import { getAllUsersApi } from "../../api/apiUrlConst";
import { toast } from "react-toastify";

interface Props {
  batches: any[];
  onViewStudents: (batchId: number) => void;
  onStudentHistory: (batch: any) => void;
}

const BatchTable: React.FC<Props> = ({ batches, onStudentHistory }) => {
  const [users, setUsers] = useState<any[]>([]);

  const role = sessionStorage.getItem("role");

  const loadUsers = async () => {
    try {
      const data = await getAllUsersApi();
      console.log("Users:", data);
      setUsers(data);
    } catch {
      toast.error("Failed to load users");
    }
  };



  const statusOrder: any = {
  Ongoing: 1,
  Upcoming: 2,
  NotStarted: 3,
  Completed: 4
};

const sortedBatches = [...batches].sort(
  (a, b) => statusOrder[a.batch1Status] - statusOrder[b.batch1Status]
);

  useEffect(() => {
    loadUsers();
  }, []);



  const userMap = Object.fromEntries(
    users.map((u: any) => [u.userId, u.name])
  );



  return (
    <Card
      className="border-0 shadow-sm"
      style={{ borderRadius: "16px", overflow: "hidden" }}
    >
      <CardBody>



        <Table
          responsive
          hover
          className="align-middle"
          style={{
            borderCollapse: "separate",
            borderSpacing: "0 8px"
          }}
        >
          <thead>
            <tr style={{ background: "#eef2f7" }}>
              <th>Batch ID</th>
              <th>Course</th>
              <th>Timing</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>Trainer</th>
              <th>Coordinator</th>
              {role === "Coordinator" && (<th style={{ width: "220px" }}>Actions</th>)}
            </tr>
          </thead>

          <tbody>
            {sortedBatches.length === 0 ? (
              <tr>
                <td colSpan={9} className="text-center text-muted py-5">
                  No batches available
                </td>
              </tr>
            ) : (
              sortedBatches.map((batch, index) => (
                <tr
                  key={batch.id}
                  style={{
                    background: "#fff",
                    boxShadow: "0 3px 10px rgba(0,0,0,0.05)",
                    borderLeft:
                      batch.batch1Status === "Completed"
                        ? "5px solid #22c55e"
                        : batch.batch1Status === "Ongoing"
                          ? "5px solid #ef4444"
                          : batch.batch1Status === "Upcoming"
                            ? "5px solid #0d6efd"
                            : "5px solid #adb5bd",
                    borderRadius: "12px",
                    transition: "0.2s"
                  }}
                >
                  {/* ID */}
                  <td className="fw-bold">{batch.id}</td>

                  {/* Batch Name */}
                  <td >
                    <span
                      className="px-3 py-2"
                      style={{
                        background: "#eef4ff",
                        borderRadius: "20px",
                        fontWeight: 600,
                        color: "#0d6efd"
                      }}
                      onClick={() => onStudentHistory(batch)}
                    >
                      {batch.batchName}
                    </span>
                  </td>
                

                  <td className="fw-semibold">
                    {batch.course2Name}
                  </td>

                 
                  <td>
                    {batch.b1StartDate && batch.b1EndDate ? (
                      <span
                        style={{
                          background: "#f1f5f9",
                          padding: "6px 12px",
                          borderRadius: "12px",
                          fontWeight: 600
                        }}
                      >
                        📅{" "}
                        {new Date(batch.b1StartDate).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                        })}{" "}
                 
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td>
                    { batch.b1EndDate ? (
                      <span
                        style={{
                          background: "#f1f5f9",
                          padding: "6px 12px",
                          borderRadius: "12px",
                          fontWeight: 600
                        }}
                      >
                       📅 {new Date(batch.b1EndDate).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                        })}
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td>
                    <span className="fw-bold ">
                      <Badge
                        color={batch.batch1Status === "NotStarted" ? "secondary"
                          : batch.batch1Status === "Completed"
                            ? "success"
                            : batch.batch1Status === "Ongoing"
                              ? "danger"
                              : batch.batch1Status === "Upcoming"
                                ? "dark"
                                : "secondary"
                        }
                      >
                        {batch.batch1Status === "NotStarted"
                          ? "NotStarted"
                          : batch.batch1Status
                        }
                      </Badge>

                    </span>
                  </td>

                   {/* Trainer */}
                  <td>
                    <span className="fw-bold">
                      {batch.course1Trainer}
                    </span>
                  </td>

                    {/* Coordinate Name */}
                  <td className="fw-semibold">
                    {userMap[batch.createdByCoordinatorId] || "-"}
                  </td>


                </tr>
              ))
            )}
          </tbody>
        </Table>

      </CardBody>
    </Card>
  );
};

export default BatchTable;